/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, ids: NonNullable<unknown> }} Deck_Unknown_CardsInputs */



/**
* | output |
* | --- |
* | "{count} card(s) not found in card database (IDs: {ids})" |
*
* @param {Deck_Unknown_CardsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_unknown_cards = /** @type {((inputs: Deck_Unknown_CardsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Unknown_CardsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} carte(s) non trouvée(s) dans la base de données (IDs : ${i?.ids})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} carta(s) no encontrada(s) en la base de datos (IDs: ${i?.ids})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} carta(s) não encontrada(s) na base de dados (IDs: ${i?.ids})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} carta/e non trovata/e nel database (IDs: ${i?.ids})`)
	return /** @type {LocalizedString} */ (`${i?.count} card(s) not found in card database (IDs: ${i?.ids})`)
});